(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('PendingOrderService', PendingOrderService);

    PendingOrderService.$inject = ['$resource'];

    function PendingOrderService ($resource) {
        var resourceUrl =  'api/pending-order-report/:id';
        
        return $resource(resourceUrl, {}, {
        	
        
        	 'getPendingOrdersForReport':{
          		isArray:true,
 				method: 'GET',
 				params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'
 						, fromTime: '@fromTime' , toTime : '@toTime' , currencyPairId : '@currencyPairId'
 				},
 				url: 'api/pending-order-report'
           },
           'exportPendingOrderExcel':{
           	 method: 'GET',
                url: 'api/pending-order-report/excel-download',
                responseType: 'arraybuffer',
                params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'
						, fromTime: '@fromTime' , toTime : '@toTime', currencyPairId : '@currencyPairId'
                },
                transformResponse: function(data, headers) {
              	  return {
                        data: data,
                        headers: headers
                    };   
                }      
           },
           'exportPendingOrderCsv':{
            	 method: 'GET',
                 url: 'api/pending-order-report/csv-download',
                 responseType: 'arraybuffer',
                 params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'
						, fromTime: '@fromTime' , toTime : '@toTime', currencyPairId : '@currencyPairId'
                 },
                 transformResponse: function(data, headers) {
               	  return {
                         data: data,
                         headers: headers
                     };   
                 }      
            },
            'exportPendingOrderPdf':{
             	 method: 'GET',
                  url: 'api/pending-order-report/pdf-download',
                  responseType: 'arraybuffer',
                  params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId'
						, fromTime: '@fromTime' , toTime : '@toTime', currencyPairId : '@currencyPairId'
                  },
                  transformResponse: function(data, headers) {
                	  return {
                          data: data,
                          headers: headers
                      };   
                  }      
             }
        });
    }
   })();
